import * as v from 'valibot';
import type { AnswerState } from './types';

const SANITIZED_ID_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/;

export const SanitizedIdSchema = v.pipe(
  v.string(),
  v.minLength(1),
  v.maxLength(128),
  v.regex(SANITIZED_ID_PATTERN),
);

export const AnswerValueSchema = v.union([
  SanitizedIdSchema,
  v.array(SanitizedIdSchema),
  v.pipe(v.number(), v.finite()),
]);

export const AnswerStateSchema = v.record(SanitizedIdSchema, AnswerValueSchema);

export const BranchSchema = v.picklist([
  'travel',
  'cash_back',
  'balance_transfer',
  'saving_interest',
  'building_credit',
]);

export function parseAnswerState(raw: unknown): AnswerState {
  const result = v.safeParse(AnswerStateSchema, raw);
  return result.success ? result.output : {};
}
